import React, { useEffect, useState, useRef } from 'react';
import authService from '../api-authorization/AuthorizeService'
import ItemsList from '../ItemsList.js';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import utils from '../../utils';
import InputGroup from 'react-bootstrap/InputGroup';
import { NumericFormat } from 'react-number-format';
import Button from 'react-bootstrap/Button';


const Inspectors = () => {
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [inspector, setInspector] = useState({});
    const updateList = useRef(true);
    const [validated, setValidated] = useState(false);
    const [inspectorValid, setInspectorValid] = useState(true);
    const [disableInput, setDisableInput] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

  /*  useEffect(() => {
        if (loading) {
            const getItems = async () => {
                const token = await authService.getAccessToken();
                const response = await fetch(`api/settings/items`, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                });

                const data = await response.json();
                await setLoading(false);
            };
            getItems();
        }
    }, [loading]);*/

    const columns = [
        { id: 'name', name: 'Name', sortable: true, filter: "search", selectId: null, labelFormat: 'clickToItem', aggregate: false }
    ];

    const mapFunction = (q) => {
        return {
            id: q.id,
            name: q.name
        }
    };

    const shouldUpdateList = () => {
        if (updateList.current) {
            updateList.current = false;
            return true;
        }
        return false;
    };

    const handleEditItem = async (id) => {
        const token = await authService.getAccessToken();
        const response = await fetch(`api/settings/inspector?id=${id}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const data = await response.json();

        setErrorMessage('');
        await setInspector(data);
        await setModalTitle('Edit Inspector');
        await setValidated(false);
        await setDisableInput(false);
        await setShowModal(true);
    };

    const handleAddItem = async () => {
        await setInspector({
            name: ''
        });

        setErrorMessage('');
        await setModalTitle('Add Inspector');
        await setValidated(false);
        await setDisableInput(false);
        await setShowModal(true);
    };

    const handleSave = async (event) => {
        const form = event.currentTarget;

        event.preventDefault();

        // checks form validitiy
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            return;
        }

        // checks for duplicate names
        const valid = await validateInspector();
        await setInspectorValid(valid);
        if (valid === false) {
            setErrorMessage('Inspector with this name already exists.')
            event.stopPropagation();
            setValidated(false);
            return;
        } 

        const token = await authService.getAccessToken();
        await fetch('api/settings/inspector', {
            method: inspector.hasOwnProperty('id') ? 'PUT' : 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(inspector),
        });

        updateList.current = true;
        await setShowModal(false);
    };

    const handleCancel = async () => {
        await setShowModal(false);
    };

    const validateInspector = async () => {
        const token = await authService.getAccessToken();
        var url = `api/settings/checkInspector?name=${inspector.name}`;
        if (typeof(inspector.id) !== 'undefined') {
            url += `&id=${inspector.id}`;
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const valid = await response.json();
        return valid;
    };

    return (
        <React.Fragment>
            <Row className="align-items-center mb-3">
                <Col className="col-6">
                    <Card.Subtitle>
                        Inspectors
                    </Card.Subtitle>
                </Col>
                <Col className="col-6 text-end">
                    <Button type="button" onClick={handleAddItem}>Add Inspector</Button>
                </Col>
            </Row>
            <ItemsList columns={columns}
                itemName="Inspector"
                addItemUrl=""
                mapFunction={mapFunction}
                getItemsUrl="api/settings/inspectors"
                uniqueIdColumn="id"
                showHeader={false}
                itemUrlBase=""
                shouldUpdate={true}
                editItemMethod={handleEditItem}
                shouldUpdateList={shouldUpdateList}
            />
            <Modal show={showModal} onHide={() => { setShowModal(false) }} backdrop="static">
                <Form noValidate validated={validated} onSubmit={handleSave}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row className="align-items-center">
                                <Col className="fw-bold col-4 p-2">Name</Col>
                                <Col className="col-8 p-2">
                                    <Form.Control type="text" defaultValue={inspector.name} required disabled={disableInput} onChange={(e) => {
                                        const item = utils.getCopy(inspector);
                                        item.name = e.target.value.trim();
                                        setInspector(item);
                                    }} />
                                </Col>
                            </Row>
                            <Row className="">
                                <Col className="col-12 p-2">
                                    <Form.Label style={{ color: 'red', display: errorMessage == '' ? 'none' : 'block' }}>{errorMessage}</Form.Label>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Container>
                            <Row className="align-items-center">
                                <Col className="col-6">
                                    <Button type="submit">Save Changes</Button>
                                </Col>
                                <Col className="col-6 text-end">
                                    <Button type="button" variant="link" onClick={handleCancel}>Cancel</Button>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Footer>
                </Form>
            </Modal>
        </React.Fragment>
    );
}

export default Inspectors;